import { gql } from '@apollo/client/core';

export const PREPARE_MODULE_REGISTRATION_PAYMENTS = gql`
  mutation PrepareModuleRegistrationPayments($module_ids: [ID!]!, $initiate_retake: Boolean) {
    prepareModuleRegistrationPayments(module_ids: $module_ids, initiate_retake: $initiate_retake) {
      amount paid outstanding cleared
      modules { module_id module_name bill_id amount paid outstanding cleared attempt_number }
    }
  }
`;
